import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureFlagsProviderService } from './feature-flags-provider.service';

/**
 * @todo: use ngrx approach
 */
@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  public isBannerSlotCreationEnabled$: Observable<boolean>;
  public isCampaignBannerCreatingEnabled$: Observable<boolean>;
  public isCampaignBannerCreatingLoading$: Observable<boolean>;
  public isAdvertiserStatsAuthorizedEnabled$: Observable<boolean>;

  constructor(
    private featureFlagProvider: FeatureFlagsProviderService,
  ) {}

  public init(): void {
    this.isBannerSlotCreationEnabled$ = this.featureFlagProvider.createBannerSlotEnabled();
    this.isCampaignBannerCreatingEnabled$ = this.featureFlagProvider.campaignBannerCreatingEnabled();
    this.isCampaignBannerCreatingLoading$ = this.featureFlagProvider.isPendingState$;
    this.isAdvertiserStatsAuthorizedEnabled$ = this.featureFlagProvider.advertiserStatsAuthorizedEnabled();

    this.isBannerSlotCreationEnabled$.subscribe();
    this.isCampaignBannerCreatingEnabled$.subscribe();
    this.isAdvertiserStatsAuthorizedEnabled$.subscribe();
  }
}
